var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.73011C0 0.774856 0.794023 0 1.77355 0H22.2265C23.2059 0 24 0.774856 24 1.73011V22.4221C24 23.3777 23.2059 24.1522 22.2265 24.1522H1.77355C0.794023 24.1522 0 23.3777 0 22.4221V1.73011ZM7.27676 20.2179V9.31184H3.65179V20.2179H7.27676ZM5.46425 7.8228C6.72836 7.8228 7.51516 6.98533 7.51516 5.93875C7.49161 4.86859 6.72836 4.05437 5.48824 4.05437C4.24824 4.05437 3.4375 4.86859 3.4375 5.93875C3.4375 6.98533 4.22413 7.8228 5.44063 7.8228H5.46425ZM12.9062 20.2179H9.28134C9.28134 20.2179 9.3289 10.3352 9.28134 9.31184H12.9063V10.856C13.388 10.1128 14.2502 9.05592 16.1731 9.05592C18.5581 9.05592 20.3464 10.6146 20.3464 13.9645V20.2179H16.7218V14.3834C16.7218 12.9173 16.1971 11.9171 14.8853 11.9171C13.884 11.9171 13.2875 12.5917 13.0255 13.2429C12.9297 13.4759 12.9062 13.8016 12.9062 14.1275V20.2179ZM12.9063 10.856V10.8935H12.8821C12.89 10.8811 12.8981 10.8686 12.9063 10.856Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/Linkedin_Icon.ae157854c09e2b024d8ccca4e805ddb4.svg";
export { ForwardRef as ReactComponent };